<script>
import Thumbnail from 'dashboard/components/widgets/Thumbnail.vue';
import { dynamicTime } from 'shared/helpers/timeHelper';

export default {
  components: {
    Thumbnail,
  },
  props: {
    notificationItem: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['openNotification'],
  computed: {
    typeIcon() {
      const type = this.notificationItem?.notification_type;
      const map = {
        conversation_mention: 'at-sign',
        conversation_assignment: 'message-circle-code',
        assigned_conversation_new_message: 'message-circle',
        participating_conversation_new_message: 'message-circle',
        conversation_creation: 'message-circle-plus',
        sla_missed_first_response: 'triangle-alert',
        sla_missed_next_response: 'triangle-alert',
        sla_missed_resolution: 'triangle-alert',
        zalo_personal_disconnected: 'message-circle-question-mark',
        ai_reply_quota_alert: 'message-circle-warning',
        channel_message_failed: 'message-circle-x',
      };
      return map[type] || 'message-circle';
    },
    notificationAssignee() {
      const { primary_actor: primaryActor } = this.notificationItem;
      return primaryActor?.meta?.assignee;
    },
    hasNotificationAssignee() {
      return !!this.notificationAssignee;
    },
    notificationAssigneeName() {
      return this.notificationAssignee?.name || '';
    },
    notificationAssigneeThumbnail() {
      return this.notificationAssignee?.thumbnail || '';
    },
  },
  methods: {
    dynamicTime,
    onClickOpenNotification() {
      this.$emit('openNotification', this.notificationItem);
    },
  },
};
</script>

<template>
  <div class="w-full">
    <woot-button
      size="expanded"
      color-scheme="secondary"
      variant="link"
      class="w-full"
      @click="onClickOpenNotification()"
    >
      <div
        class="flex-row items-center p-2.5 leading-[1.4] border-b border-solid border-slate-50 dark:border-slate-700 flex w-full hover:bg-slate-75 dark:hover:bg-slate-900 hover:rounded-md"
      >
        <div
          v-if="!notificationItem.read_at"
          class="w-2 h-2 rounded-full bg-hichat-500"
        />
        <div v-else class="flex w-2" />
        <div
          class="flex-col ml-2.5 overflow-hidden w-full flex justify-between"
        >
          <div class="flex justify-between items-start mb-1">
            <div class="flex items-center gap-2 flex-1 min-w-0">
              <div
                v-if="!hasNotificationAssignee"
                class="flex items-center justify-center w-5 h-5 rounded-full bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300"
              >
                <!-- <fluent-icon :icon="typeIcon" size="14" /> -->
                <lucide-icon :name="typeIcon" size="14" />
              </div>
              <span class="font-bold text-slate-800 dark:text-slate-100">
                {{
                  `#${
                    notificationItem.primary_actor
                      ? notificationItem.primary_actor.id
                      : $t(`NOTIFICATIONS_PAGE.DELETE_TITLE`)
                  }`
                }}
              </span>
              <span
                v-if="notificationItem.inbox_name"
                class="text-xxs p-0.5 px-1.5 my-0 bg-n-gray-1 dark:bg-n-gray-3 text-hilab dark:text-hilab rounded-md font-medium"
                :title="notificationItem.inbox_name"
              >
                {{ notificationItem.inbox_name }}
              </span>
              <span
                class="text-xxs p-0.5 px-1 my-0 mx-2 bg-slate-50 dark:bg-slate-700 rounded-md"
              >
                {{
                  $t(
                    `NOTIFICATIONS_PAGE.TYPE_LABEL.${notificationItem.notification_type}`
                  )
                }}
              </span>
            </div>
            <div v-if="hasNotificationAssignee" class="shrink-0 ml-2">
              <Thumbnail
                :src="notificationAssigneeThumbnail"
                size="16px"
                :username="notificationAssigneeName"
              />
            </div>
          </div>
          <div class="flex flex-col w-full gap-1">
            <span
              class="overflow-hidden font-semibold text-left text-slate-800 dark:text-slate-100 text-sm line-clamp-1"
            >
              {{ notificationItem.push_message_title }}
            </span>
            <span
              v-if="notificationItem.push_message_body"
              class="overflow-hidden font-normal text-slate-600 dark:text-slate-300 text-xs line-clamp-2 text-left"
            >
              {{ notificationItem.push_message_body }}
            </span>
          </div>
          <span
            class="flex mt-1 font-semibold text-slate-500 dark:text-slate-400 text-xxs"
          >
            {{ dynamicTime(notificationItem.last_activity_at) }}
          </span>
        </div>
      </div>
    </woot-button>
  </div>
</template>
